import { createContext, useContext, useState, useEffect } from "react";

const translations = {
  id: {
    // Nav
    nav_home: "Home",
    nav_rooms: "Our Rooms",
    nav_gallery: "Gallery",
    nav_facilities: "Facilities",
    nav_about: "About Us",
    nav_contact: "Contact",
    nav_book: "Book Now",

    // Hero
    hero_badge: "Motel Modern · Solo, Indonesia",
    hero_title_1: "Istirahat.",
    hero_title_2: "Segarkan.",
    hero_title_3: "Lanjut lagi.",
    hero_welcome: "Selamat Datang di",
    hero_sub_1: "Konsep",
    hero_sub_2: "motel modern",
    hero_sub_3: "dan adaptif di tengah kota. Menyediakan",
    hero_sub_4: "13 kamar eksklusif",
    hero_sub_5: "yang dirancang khusus untuk kenyamanan istirahat Anda tanpa menguras kantong.",
    hero_cta: "Jelajahi Kamar Kami",
    hero_about_btn: "Tentang Loka Beds",
    hero_stat_location: "Banjarsari, Surakarta",
    hero_stat_rooms: "Kamar Eksklusif",
    hero_stat_reception: "Reception",
    hero_featured: "Unggulan",
    hero_night: "/ malam",

    // About
    about_kicker: "— Tentang Loka Beds",
    about_word_1: "Eksklusif.",
    about_word_2: "Tenang.",
    about_word_3: "Adaptif.",
    about_p1_1: "hadir sebagai",
    about_p1_2: "motel modern",
    about_p1_3:
      "yang menggabungkan fleksibilitas, kenyamanan, dan fungsionalitas di lokasi strategis. Dengan jumlah kamar yang terbatas",
    about_p1_4: "(hanya 13 kamar)",
    about_p1_5:
      ", kami memastikan setiap tamu mendapatkan suasana yang tenang, privat, dan pelayanan yang lebih personal.",
    about_p2_pre: "Kami percaya bahwa",
    about_p2_em: "tempat istirahat yang nyaman tidak harus mahal.",
    about_stat_rooms: "Kamar Eksklusif",
    about_stat_reception: "Reception Ramah",
    about_stat_priv: "Privat & Tenang",

    // Rooms
    rooms_kicker: "— Kamar Kami",
    rooms_title_1: "Dua tipe kamar,",
    rooms_title_2: "satu standar kenyamanan.",
    rooms_lead:
      "Total 13 kamar. Setiap ruang dirancang minimalis, bersih, dan fungsional agar Anda bisa istirahat maksimal.",
    room_available_single: "6 Kamar Tersedia",
    room_available_double: "7 Kamar Tersedia",
    room_single_title: "Single Room",
    room_double_title: "Double Room",
    room_capacity_single: "1 Tamu",
    room_capacity_double: "2 Tamu",
    room_start_from: "Mulai dari",
    room_night: "/ malam",
    room_choose_plan: "Pilih Paket Menginap",
    tier_flexytime_sub: "6 Jam",
    tier_flexy24_sub: "24 Jam",
    tier_flexyregular_sub: "C-IN 14:00 / C-OUT 11:00",
    room_desc_single:
      "Kamar privat minimalis untuk Anda yang butuh ketenangan setelah seharian berkendara atau beraktivitas. Cocok untuk solo traveler dan backpacker.",
    room_desc_double:
      "Ruang lebih luas dengan fasilitas lengkap untuk kenyamanan ekstra berdua. Cocok untuk pasangan atau trip bisnis.",
    room_book_cta: "Booking via WhatsApp",
    room_wa_msg: "Halo Loka Beds, saya ingin menanyakan ketersediaan",
    room_amenity_single_1: "1 Single Bed Premium",
    room_amenity_single_2: "AC Dingin",
    room_amenity_single_3: "Free Wi-Fi Super Cepat",
    room_amenity_single_4: "Kamar Mandi Bersama (Bersih & Estetik)",
    room_amenity_double_1: "1 Double Bed (Queen Size)",
    room_amenity_double_2: "Kamar Mandi Dalam (Shower Air Panas)",
    room_amenity_double_3: "AC & Smart TV",
    room_amenity_double_4: "Meja Kerja Minimalis",
    room_amenity_double_5: "Free Wi-Fi Super Cepat",

    // Gallery
    gallery_kicker: "— Galeri",
    gallery_title: "Kehidupan di Loka Beds",
    gallery_lead:
      "Foto-foto asli dari kamar, kamar mandi, hingga detail amenities. Semua tenang, bersih, dan siap dipakai istirahat.",

    // Facilities
    fac_kicker: "— Fasilitas",
    fac_title: "Fasilitas Premium Kami",
    fac_lead:
      "Fasilitas esensial yang kami rancang untuk membuat setiap malam di Loka Beds terasa efisien, hangat, dan personal.",
    fac_wifi_title: "Wi-Fi Super Cepat",
    fac_wifi_text:
      "Koneksi internet stabil di seluruh area motel untuk kebutuhan kerja atau streaming tanpa lag.",
    fac_house_title: "Housekeeping Harian",
    fac_house_text:
      "Layanan kebersihan berkala untuk memastikan lingkungan kamar dan area motel selalu higienis, rapi, dan nyaman ditempati.",
    fac_rec_title: "Reception 24 Jam",
    fac_rec_text:
      "Tim kami ramah dan siap membantu kebutuhan check-in, check-out, serta informasi Anda kapan saja.",

    // Footer
    foot_tagline:
      "Rest. Reset. Go again. Motel modern dengan 13 kamar eksklusif di jantung Kota Surakarta.",
    foot_location: "Lokasi",
    foot_contact: "Hubungi Kami",
    foot_follow: "Ikuti Kami",
    foot_follow_note: "Update kamar, promo, dan momen tamu terbaru.",
    foot_copyright_slogan: "Tetap Cerdas, Tetap Modern.",

    // Lang toggle
    lang_toggle_aria: "Ganti bahasa",
  },
  en: {
    nav_home: "Home",
    nav_rooms: "Our Rooms",
    nav_gallery: "Gallery",
    nav_facilities: "Facilities",
    nav_about: "About Us",
    nav_contact: "Contact",
    nav_book: "Book Now",

    hero_badge: "Modern Motel · Solo, Indonesia",
    hero_title_1: "Rest.",
    hero_title_2: "Reset.",
    hero_title_3: "Go again.",
    hero_welcome: "Welcome to",
    hero_sub_1: "A",
    hero_sub_2: "modern motel",
    hero_sub_3: "concept in the heart of the city. We offer",
    hero_sub_4: "13 exclusive rooms",
    hero_sub_5: "designed specifically for your comfort — without breaking the bank.",
    hero_cta: "Explore Our Rooms",
    hero_about_btn: "About Loka Beds",
    hero_stat_location: "Banjarsari, Surakarta",
    hero_stat_rooms: "Exclusive Rooms",
    hero_stat_reception: "Reception",
    hero_featured: "Featured",
    hero_night: "/ night",

    about_kicker: "— About Loka Beds",
    about_word_1: "Exclusive.",
    about_word_2: "Quiet.",
    about_word_3: "Adaptive.",
    about_p1_1: "arrives as a",
    about_p1_2: "modern motel",
    about_p1_3:
      "combining flexibility, comfort, and functionality in a strategic location. With a limited number of rooms",
    about_p1_4: "(only 13 rooms)",
    about_p1_5:
      ", we ensure every guest enjoys a quiet, private atmosphere with more personal service.",
    about_p2_pre: "We believe that",
    about_p2_em: "a comfortable place to rest doesn't have to be expensive.",
    about_stat_rooms: "Exclusive Rooms",
    about_stat_reception: "Friendly Reception",
    about_stat_priv: "Private & Quiet",

    rooms_kicker: "— Our Rooms",
    rooms_title_1: "Two room types,",
    rooms_title_2: "one standard of comfort.",
    rooms_lead:
      "13 rooms total. Each space is designed to be minimalist, clean, and functional so you can rest to the fullest.",
    room_available_single: "6 Rooms Available",
    room_available_double: "7 Rooms Available",
    room_single_title: "Single Room",
    room_double_title: "Double Room",
    room_capacity_single: "1 Guest",
    room_capacity_double: "2 Guests",
    room_start_from: "Starting from",
    room_night: "/ night",
    room_choose_plan: "Choose Your Stay",
    tier_flexytime_sub: "6 Hours",
    tier_flexy24_sub: "24 Hours",
    tier_flexyregular_sub: "C-IN 2PM / C-OUT 11AM",
    room_desc_single:
      "A minimalist private room for those who need quiet after a long day on the road. Perfect for solo travelers and backpackers.",
    room_desc_double:
      "A more spacious room with complete facilities for extra comfort as a duo. Perfect for couples or business trips.",
    room_book_cta: "Book via WhatsApp",
    room_wa_msg: "Hello Loka Beds, I'd like to ask about the availability of",
    room_amenity_single_1: "1 Premium Single Bed",
    room_amenity_single_2: "Cool AC",
    room_amenity_single_3: "Super Fast Free Wi-Fi",
    room_amenity_single_4: "Shared Bathroom (Clean & Aesthetic)",
    room_amenity_double_1: "1 Double Bed (Queen Size)",
    room_amenity_double_2: "Private Bathroom (Hot Shower)",
    room_amenity_double_3: "AC & Smart TV",
    room_amenity_double_4: "Minimalist Work Desk",
    room_amenity_double_5: "Super Fast Free Wi-Fi",

    // Gallery
    gallery_kicker: "— Gallery",
    gallery_title: "Life at Loka Beds",
    gallery_lead:
      "Real photos — from the rooms and bathrooms to the amenities. All calm, clean, and ready for you to rest.",

    fac_kicker: "— Facilities",
    fac_title: "Our Premium Facilities",
    fac_lead:
      "Essential facilities crafted so that every night at Loka Beds feels efficient, warm, and personal.",
    fac_wifi_title: "Super Fast Wi-Fi",
    fac_wifi_text:
      "A stable internet connection across the motel for uninterrupted work or streaming.",
    fac_house_title: "Daily Housekeeping",
    fac_house_text:
      "Scheduled cleaning to ensure that your room and the motel area remain hygienic, tidy, and comfortable.",
    fac_rec_title: "24-Hour Reception",
    fac_rec_text:
      "Our friendly team is ready to assist with check-in, check-out, and any information you need — anytime.",

    foot_tagline:
      "Rest. Reset. Go again. A modern motel with 13 exclusive rooms in the heart of Surakarta.",
    foot_location: "Location",
    foot_contact: "Contact Us",
    foot_follow: "Follow Us",
    foot_follow_note: "Latest rooms, promos, and guest moments.",
    foot_copyright_slogan: "Stay Smart, Stay Modern.",

    lang_toggle_aria: "Switch language",
  },
};

const LanguageContext = createContext({
  lang: "id",
  setLang: () => {},
  t: (k) => k,
});

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    try {
      return localStorage.getItem("loka_lang") || "id";
    } catch {
      return "id";
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem("loka_lang", lang);
      document.documentElement.lang = lang;
    } catch {}
  }, [lang]);

  const t = (key) => translations[lang]?.[key] ?? translations.id[key] ?? key;

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);
